import { render, staticRenderFns } from "./UsageRatingUOMList.vue?vue&type=template&id=79c12706&scoped=true"
import script from "./UsageRatingUOMList.vue?vue&type=script&lang=js"
export * from "./UsageRatingUOMList.vue?vue&type=script&lang=js"
import style0 from "./UsageRatingUOMList.vue?vue&type=style&index=0&id=79c12706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c12706",
  null
  
)

export default component.exports